import { css } from "@emotion/css";

import { yellow } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export function createTutorialTestPageStyles({ spacing }: Theme) {
  return {
    detailLayoutBox: css({
      paddingTop: spacing(5),
    }),
    loaderWrapper: css({
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: yellow[400],
      width: "100%",
      minHeight: 400,
    }),
    submitButton: css({
      display: "flex",
      minWidth: 200,
      marginLeft: "auto",
    }),
  };
}
